import { useState, useEffect, useCallback } from 'react';
import { safeFetch } from '@go-client/lib/api';
import { groupResourceClient } from '@go-client/lib/api/v2/groupResource';
import { ResourceData, ResourceDataSchema } from '@go-client/components/GroupBookingForm/Workflows';

export function useGroupResourceData(brandId: string) {
  const [resourceData, setResourceData] = useState<ResourceData>({
    resourceTypes: [],
    resources: [],
  });
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await safeFetch(
        groupResourceClient.getResourcesAndTypes({
          params: { brandId },
        }),
        ResourceDataSchema
      );
      setResourceData(res);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [brandId]);

  useEffect(() => {
    fetchData();
  }, [brandId]);

  return { resourceData, loading, setLoading, refresh: fetchData };
}
